import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import modsFactoryApi from '../../api/modsFactoryApi';
import { UserInterface } from "../../store/mods_factory/usersSlice";
import modsfactoryUrls from "../../configs/mods_factory/modsfactoryUrls";

const PREFIX = 'mods_factory';

const processStrategy = (value: any) => {
  return {
    ...value,
    avatar_url: modsfactoryUrls.remoteUrl(value.avatar_url),
    bundle_ico_url: modsfactoryUrls.remoteUrl(value.bundle_ico_url),
    url: modsfactoryUrls.userPath(value.id)
  };
}

export const usersEntity = new schema.Entity(
  'users',
  {},
  {
    processStrategy
  }
);

export const userEntity = new schema.Entity(
  'user',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      user: UserInterface
    }
  >(response.data.user, userEntity);
  return normalized.entities;
}

export const fetchUsers = createAsyncThunk(
  `${PREFIX}_users/fetchUsers`,
  async (params: object = {}) => {
    const response    = await modsFactoryApi.get(`/onesky/users`, { params })
    const normalized  = normalize<
      any,
      {
        users: { [key: string]: UserInterface },
      }
    >(response.data.users, [usersEntity]);
    let previewAddons: number[] = [];

    if (normalized.entities.users) {
      Object.values(normalized.entities.users).forEach((user: UserInterface) => {
        if (user.last_addons) {
          previewAddons = [...previewAddons, ...user.last_addons];
        }
      });
    }

    return {
      previewAddons: previewAddons,
      users: normalized.entities?.users || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchUser = createAsyncThunk(
  `${PREFIX}_users/fetchUser`,
  async (id: number | string) => {
    const response = await modsFactoryApi.get(`/onesky/users/${id}`);
    return normalizeInstance(response);
  }
);

export const updateUser = createAsyncThunk(
  `${PREFIX}_users/updateUser`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/users/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const blockUser = createAsyncThunk(
  `${PREFIX}_users/blockUser`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await modsFactoryApi.patch(`/onesky/users/${id}/block`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyUser = createAsyncThunk(
  `${PREFIX}_users/destroyUser`,
  async (id: number) => {
    await modsFactoryApi.delete(`/onesky/users/${id}`);
    return { id: id };
  }
);
